import { Sop } from "src/app/models/sop";

  export function convertGraphqlSopToDto(input: string): Sop {
    return {
      name: input,
    }
  }
